import React from 'react';
import { Link } from 'react-router-dom';

export default class NavigationLinks extends React.Component {
    render(){
	// TODO
	// add hamburger on xs
	
	let links = [	
		     {name: "Our Initiatives",
		      url: "/initiatives"},
		     {name: "Trailblazers Program",
		      url: "/trailblazers"},
		     {name: "Press",
		      url: "/press"},
		     {name: "Donate",
		      url: "/donate"},
		     /*
			{name: "Join Our Team",
			url: "/join-our-team"},
		      */
		     /*
			{name: "",
			url: ""},
			{name: "",
			url: ""},
		      */
	];
	return (
	    <div style={this.props.style}>
		{links.map((link, index) =>
		    <Link to={link.url} className="hover" key={index} style={{fontFamily: "Nunito", display: this.props.fullWidth ? 'block' : 'inline-block'}} onClick={this.props.clickCallback ? this.props.clickCallback : null}>
			{link.name}
		    </Link>
		)}
		<Link to={"/contact"} className="hover" style={{fontFamily: "Nunito", border: "2px solid white", marginLeft: '1rem', borderRadius: "20px", display: this.props.fullWidth ? 'block' : 'inline-block'}} onClick={this.props.clickCallback ? this.props.clickCallback : null}>
		    {"Contact Us"}
		</Link>
	    </div>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/navigationLinks.jsx